import ContactForm from "../components/ContactForm";

const ContactPage = () => {
    return <div><ContactForm /></div>;
};

export default ContactPage;